import { DateRange, Sleeps } from "./room-mock.service";
import { ResortInventory, InventoryPrice } from "../../models/presentation.model";

export class Room {
    id: string;
    resortName: string;
    roomType: string;
    available: boolean;
    img: string[];
    stays: string;
    staysLabel: string;
    dateRange: DateRange;
    sleeps: Sleeps;
    marketRate: number;
    memberRate: number;
    memberRateLabel: string;
    memberCurrency: number;
    memberCurrencyLabel: string;
    availableOnDate: Date;
    showPricePerDay: boolean;
    hasDiscount: boolean;
    discountLabel: string;
    purchaseLabel: string;
    inventory: ResortInventory;
    reward: number;
    rewardLabel: string;
    rewardPercent: number;
    rewardActionLabel: string;
    showRewardsPerDay: boolean;

    public get hasEarnReward(): boolean{
        return this.reward > 0;
    }

    public get isUpgradeAvailable(): boolean{
        return this.inventory.resortInventoryPriceList.where(p => p.purchaseTypeCategoryId === 3).count() > 0;
    }

    public get upgradePricing(): InventoryPrice{
        return this.inventory.resortInventoryPriceList.firstOrDefault(p => p.purchaseTypeCategoryId === 3);
    }

    public get discountedPricingWithRewards(): InventoryPrice {
        return this.inventory.resortInventoryPriceList.firstOrDefault(p => p.purchaseTypeCategoryId === 2 && p.reward > 0);
    }

    public get displayMemberRate(): number{
        if(this.showPricePerDay){
            return this.memberRate;
        }
        else{
           return Math.round(Number.parseInt(this.stays) * this.memberRate);
        }
    }

    public get displayMarketRate(): number{
        if(this.showPricePerDay){
            return this.marketRate;
        }
        else{
            return Math.round(Number.parseInt(this.stays) * this.marketRate);
        }
    }

    constructor(){}
}

export class ResortRoomsByNight {
    public nights: number;
    public rooms: Room[];
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/Room.model.ts